import React from 'react';
import Survey from '../cart/survey';

const SurveyPage: React.FC = () => {
  return (
    <div className="container first-container">
      <div className="py-5">
        <Survey />
      </div>
    </div>
  );
};

export default SurveyPage;
